export const specialEmojiIndex = 99;
/** Для включения замените на true и поменяйте картинку ./specialEmoji.png на актуальную */
export const isSpecialEmojiActive = false;

const emojiesPack = [
    'goose',
    '😁',
    '😍',
    '❤️',
    '👍',
    '🗿',
    '😐',
    '😢',
    '😱',
    '👎',
    '🤡',
    '🎉',
    '👏',
    '🚀',
    '💯',
    '🔥',
    '😡',
    '🥱'
];

export const emojiesCount = emojiesPack.length;

const shouldNotRotateEmojies = ['👍', '👎', '🚀', '💯', '🔥', '🗿'];

export const emojies = [
    ...emojiesPack,
    // FOR BIG EMOJIES
    ...emojiesPack,
    // emoji to some event, not permanent in array
    'specialEmoji',
];

export const getShouldEmojiRotate = (emojiIndex: number) => {
    const emoji = emojies[emojiIndex];

    if (!emoji) {
        return false;
    }

    return !shouldNotRotateEmojies.includes(emoji);
};
